import { Directive, EventEmitter, HostListener } from "@angular/core";

@Directive({ selector: 'scrollable, .scrollable, [scrollable]' })
export class ScrollableDirective {
	onScroll = new EventEmitter<void>();
	@HostListener('scroll') scroll(event: Event) {
		this.onScroll.next();
	}
}

